import { ApiListActionStatusesResponse } from '../../../api/core/models';
import { ACTION_STATUS, BoardSettingsV2 } from '../model';

export function apiBoardSettingsToSwimlanes(
  actionStatusesResponse?: ApiListActionStatusesResponse
): NonNullable<BoardSettingsV2['swimlanes']> {
  if (!actionStatusesResponse?.actionStatuses) {
    return [];
  }
  return actionStatusesResponse.actionStatuses.map((actionStatus) => ({
    id: actionStatus.id,
    title: actionStatus.displayValue,
    type: <ACTION_STATUS>actionStatus.status,
  }));
}
